module.exports = __webpack_public_path__ + "static/media/thankyou.66da8255.png";